module.exports = __webpack_public_path__ + "static/media/medical-history-off.c38feb40.svg";